<template>
  <div>
    <div class="content-wrapper"
         style="margin-top: 0px;">
      <!-- Main content -->
      <section class="content">
        <div class="container">
          <div item_name="弈写免责声明"
               class="service_item"
               style="background-color: #fff;padding:20px 20px 20px 20px;min-height:400px;">
            <h3 class="cm_t1">弈写免责声明</h3>
            <div>
              <h4 class="cm_t2">本产品“弈写”版权归属云天弈（北京）信息技术有限公司 （以下简称“云天弈”）所有，本声明的所有内容最终解释权归云天弈。</h4>
            </div>
            <p>1. 弈写仅为用户写作提供事件梳理和素材整合参考，弈写不对用户发表、转载的内容提供任何形式的保证。因网络状况、通讯线路、第三方网站或管理部门的要求等任何原因而导致您不能正常使用弈写，弈写不承担任何法律责任。</p>
            <p>2. 用户在通过弈写辅助创作发表的内容，仅表明其个人的立场和观点，并不代表弈写的立场或观点。弈写仅为用户内容创作提供辅助参考。作为内容的发表者，需自行对所发表内容负责，因所发表内容引发的一切纠纷，由该内容的发表者承担全部法律及连带责任。云天弈不承担任何法律及连带责任。</p>
            <p>3. 弈写提供的参考内容均来自互联网已发表的公开信息，本公司不拥有著作权，仅供用户参考。用户利用本服务可能侵犯第三方著作权或其他知识产权的，用户应遵守相关法律法规，取得合法授权或许可；若权利人对于用户使用本服务产生的任何内容享有合法权利的，应及时通知云天弈并提交合法权利声明，云天弈将依据相关法律法规采取移除、删除或屏蔽等处理措施。
              联系我们请Email：contactus@yuntianyi.com
            </p>
            <p>4、本站对任何直接、间接、偶然、特殊及继起的损害不负责任，这些损害可能来自：不正当使用网络服务，非法使用网络服务或用户传送的信息有所变动。这些行为都有可能会导致本站的形象受损，所以本站事先提出这种损害的可能性。</p>
            <p>5、如因不可抗力或其他本站无法控制的原因（包括但不限于计算机病毒、黑客攻击、第三方恶意行为等）使本站销售系统崩溃或无法正常使用导致丢失有关的信息、记录等，云天弈不承担责任。但是云天弈会尽可能合理地协助处理善后事宜，并努力使客户免受损失。除了本站的使用条件中规定的其它限制和除外情况之外，在中国法律法规所允许的限度内，对于因使用本站服务而引起的或与之有关的任何直接的、间接的、特殊的、附带的、后果性的或惩罚性的损害，或任何其它性质的损害，本站、本站的董事、管理人员、雇员、代理或其它代表在任何情况下都不承担责任。</p>
            <p>6、登录使用本系统，视为同意本声明。</p>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>

export default {
  name: 'aliPay',
  data: function () {
    return {

    }
  },
  methods: {

  },
  components: {

  },
  mounted () {

  },
  watch: {

  }
}
</script>

<style lang="less" scoped>
@import "../assets/css/doc.css";
.content {
  max-width: 800px;
  width: 100%;
  text-align: left;
  margin: auto;
  overflow-y: auto;
  font-size: 16px;
  line-height: 32px;
}
</style>



// WEBPACK FOOTER //
// src/app/disclaimer.vue